export default "__VITE_ASSET__BaUV$Vrp__"